import React from "react"
import {Transition} from "react-transition-group"

import LeftWorkHeader from "../LeftWorkHeader/LeftWorkHeader"
import FormEdit from "./FormEdit"

import "./leftworkeditimage.scss"

/**
 * Window for edit text
 * @component
 * @param  {object} props
 * @param  {boolean} props.active - window state
 *
 * @example
 * const active = false
 *
 * return (
 *  <LeftWorkEditImage
 *    active={active}
 *  />
 * )
 */

const LeftWorkEditImage = ({active}) => {
  return (
    <Transition in={active} timeout={200} unmountOnExit={true}>
      {state => (
        <div
          className="leftWorkEditImageContainer"
          style={{
            ...transitionStyles[state],
          }}
        >
          <LeftWorkHeader title="Edit Image" />
          <div className="leftWorkEditImageContent">
            <FormEdit />
          </div>
        </div>
      )}
    </Transition>
  )
}

export default LeftWorkEditImage

const transitionStyles = {
  entering: {opacity: 0},
  entered: {opacity: 1, position: "relative"},
  exiting: {opacity: 0},
  exited: {opacity: 0},
}
